import { Link } from "components/Link";
import { RichTextModule } from "components/RichTextModule";
import { ResponsiveImage } from "components/ResponsiveImage";
import React from "react";

import styles from "./authorModule.module.scss";
import articleContainerStyles from "./articleContainer.module.scss";

export interface AuthorBlock {
    biography: string;
    email: string;
    headshotUrl: string;
    writerName: string;
    writerSlug: string;
}

interface BioImageDimensionProps {
    mobileWidth: number;
    mobileHeight: number;
    tabletWidth: number | null;
    tabletHeight: number | null;
}

/**
 * Creates an author block.  Accepts small or large to decide if this is a sidebar or footer block.
 * @example
 * <AuthorModule
 *     biography={props.contentAuthor.biography}
 *     email={props.contentAuthor.email}
 *     headshotUrl={props.contentAuthor.headshotUrl}
 *     writerName={props.contentAuthor.writerName}
 *     writerSlug={props.contentAuthor.writerSlug}
 * />
 */
export const AuthorModule: React.FC<AuthorBlock> = ({
    biography,
    headshotUrl,
    writerName,
    writerSlug
}) => {
    const wrapperClass = `${articleContainerStyles.contentModule} ${styles.author}`;
    const writerUri = `/author/${writerSlug}`;
    const bioImageDimensions: BioImageDimensionProps = {
        mobileWidth: 76,
        mobileHeight: 76,
        tabletWidth: 108,
        tabletHeight: 108
    };

    return !writerName ? null : (
        <>
            <aside className={wrapperClass}>
                <Link className={styles.headshot} href={writerUri}>
                    <ResponsiveImage
                        loading="lazy"
                        round={true}
                        altText={writerName}
                        url={headshotUrl}
                        {...bioImageDimensions}
                    />
                </Link>
                <div className={styles.bio}>
                    <RichTextModule type="richTextBlock" {...{ richText: biography }} />
                    <Link className={`${styles.readMore} ${styles.callToAction}`} href={writerUri}>
                        More from&nbsp;
                        {writerName}
                        <span className="fa fa-angle-right" />
                    </Link>
                </div>
            </aside>
        </>
    );
};
